import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router';

import Icon, { Icons } from '@shared/Icons/Icon';
import getUrl from '@/routes/routes/helpers/getUrl';
import * as styles from './styles.module.css';

import Login from '../../base-styles/Login';

import { MicroTrustScoreComponent } from '../../components/Trustpilot';
import Logo from '../../components/Logo';

import { useLocale } from '../../hooks/useLocale';

const imageUrlGB =
  'https://res.cloudinary.com/letsdothiscom/image/upload/v1584536304/static-assets/my-events-gb.png';
const imageUrlUS =
  'https://res.cloudinary.com/letsdothiscom/image/upload/v1584536304/static-assets/my-events-us.png';

const MyEventsProductMarketing = (props) => {
  const header = props.header;
  const signUpText = props.signUpText;
  const locale = useLocale();
  const imageUrl = locale === 'us' ? imageUrlUS : imageUrlGB;

  const renderFooter = () => (
    <p className={styles.terms}>
      By creating an account, you accept our <Link to="/terms">terms</Link>.
    </p>
  );

  return (
    <div className={styles.layoutContainer}>
      <div className={styles.leftContainer}>
        <div className={styles.closeBtnContainer}>
          <div className={styles.mobileLogo}>
            <Logo />
          </div>
          <button
            type="button"
            className={styles.closeBtn}
            onClick={props.onClose}
          >
            <Icon icon={Icons.CROSS.BLACK} />
          </button>
        </div>
        <div>
          <h1 className={styles.title}>{header}</h1>
        </div>
        <div>
          <p className={styles.info}>
            <span style={{ display: 'inline-block' }}>
              <span className={styles.strong}>My Bookings</span> keeps your
              bookings, event information and race history, all in one place.
            </span>
          </p>
        </div>
        <div>
          <p
            className={[
              styles.red,
              styles.normalFontWeight,
              styles.noMargin,
            ].join(' ')}
          >
            {signUpText}
          </p>
          <div className={styles.overrideLock}>
            <Login
              transparentLayout
              renderLogo={() => true}
              blurb=""
              heading=""
              renderFooter={renderFooter}
              customReturnUrl={getUrl.myEvents()}
              lockExtraStyles={styles.overrideLock}
              optionsOnly
            />
          </div>
        </div>
        <div className={styles.logoReviews}>
          <div className={styles.logoLine}>
            <Logo />
          </div>
          <div className={styles.reviewLine}>
            <MicroTrustScoreComponent />
          </div>
        </div>
      </div>
      <div className={styles.imgContainer}>
        <img src={imageUrl} className={styles.img} alt="My Events Product" />
      </div>
    </div>
  );
};

MyEventsProductMarketing.propTypes = {
  header: PropTypes.string,
  signUpText: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

MyEventsProductMarketing.defaultProps = {
  header: 'The simplest way to record your race history',
  signUpText: 'Sign-up to get started: ',
};

export default MyEventsProductMarketing;
